import { useCallback, useContext } from 'react';
import { Typeahead } from 'react-bootstrap-typeahead';
import { OrderContext } from '../../OrderStore/index';

const LegsFilter = () => {
  const { filterConfigs, setFilterConfigs, intentArray } = useContext(OrderContext);

  const handleLegsUpdate = useCallback((selectedLegs) => {
    setFilterConfigs({
      ...filterConfigs,
      legs: selectedLegs.map((selection) => selection.id),
    });
  }, [filterConfigs, setFilterConfigs]);

  return (
    <div className="legs-filter-container justify-content-end mb-2">
      <div className="quick-adjustment">
        <Typeahead
          id="quick-adjustments-legs"
          className="quick-legs"
          labelKey="label"
          multiple
          onChange={handleLegsUpdate}
          options={intentArray}
          placeholder="Filter Legs..."
          positionFixed
        />
      </div>
    </div>
  );
};

export default LegsFilter;
